/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Approve Clubhouse Reservation Request Schema
 * @export
 * @interface ApproveClubhouseReservationRequestRequest
 */
export interface ApproveClubhouseReservationRequestRequest {
    /**
     * Response
     * @type {string}
     * @memberof ApproveClubhouseReservationRequestRequest
     */
    response: string;
}

/**
 * Check if a given object implements the ApproveClubhouseReservationRequestRequest interface.
 */
export function instanceOfApproveClubhouseReservationRequestRequest(value: object): value is ApproveClubhouseReservationRequestRequest {
    if (!('response' in value) || value['response'] === undefined) return false;
    return true;
}

export function ApproveClubhouseReservationRequestRequestFromJSON(json: any): ApproveClubhouseReservationRequestRequest {
    return ApproveClubhouseReservationRequestRequestFromJSONTyped(json, false);
}

export function ApproveClubhouseReservationRequestRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApproveClubhouseReservationRequestRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'response': json['response'],
    };
}

export function ApproveClubhouseReservationRequestRequestToJSON(value?: ApproveClubhouseReservationRequestRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'response': value['response'],
    };
}

